interface FormatDateOptions {
  locale?: string;
}

export function formatDate(
  date: Date | string | number,
  options: FormatDateOptions = {}
): string {
  const { locale = 'es-AR' } = options;
  const d = new Date(date);

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(d);
}

export function formatDateTime(
  date: Date | string | number,
  options: FormatDateOptions = {}
): string {
  const { locale = 'es-AR' } = options;
  const d = new Date(date);

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d);
}

export function formatRelativeTime(
  date: Date | string | number,
  options: FormatDateOptions = {}
): string {
  const { locale = 'es-AR' } = options;
  const d = new Date(date);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - d.getTime()) / 1000);

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

  if (diffInSeconds < 60) {
    return rtf.format(-diffInSeconds, 'second');
  }
  if (diffInSeconds < 3600) {
    return rtf.format(-Math.floor(diffInSeconds / 60), 'minute');
  }
  if (diffInSeconds < 86400) {
    return rtf.format(-Math.floor(diffInSeconds / 3600), 'hour');
  }
  if (diffInSeconds < 2592000) {
    return rtf.format(-Math.floor(diffInSeconds / 86400), 'day');
  }
  if (diffInSeconds < 31536000) {
    return rtf.format(-Math.floor(diffInSeconds / 2592000), 'month');
  }
  return rtf.format(-Math.floor(diffInSeconds / 31536000), 'year');
}


export function formatDateExact(date: string | Date) {
  const d = new Date(date);

  const month = d
    .toLocaleString('es-MX', { month: 'short' })
    .replace('.', '');

  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();

  return `${capitalize(month)} ${day}, ${year}`;
};

export const formatDateTimeExact = (date: string | Date) => {
  const d = new Date(date);

  const month = d
    .toLocaleString('es-MX', { month: 'short' })
    .replace('.', '');

  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();

  const time = d.toLocaleString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

  return `${capitalize(month)} ${day} ${year}, ${time}`;
};

const capitalize = (value: string) =>
  value.charAt(0).toUpperCase() + value.slice(1);
